<template>
  <div class="dashboard_page_employee">
    <!-- d-flex items-center gap-4 -->
    <div class="db_head ">
      <h4>Welcome, {{ checkProperty(getUserData, 'firstName') }}!</h4>
      <p :aria-live="'polite'">{{ sublineText }}</p>
    </div>
    
    <!-- <div v-if="loading" class="loading-state">
      <p>Checking your tasks...</p>
    </div> -->

    <NoDataFound ref="NoDataFoundRef" v-if="error" :checkLocading="false" :heading="'We couldn\'t load your tasks.'"
        type='petitioner' @retry="getStats()" :isError="error" />

    <!-- <div v-if="error" class="error-banner">
      <p>We couldn't load your tasks.</p>
      <button class="btn-retry" @click="retry">Try again</button>
    </div> -->

    <div ref="db_container" class="db_content" v-if="!loading && !error">
      <section v-if="hasTasks" class="tasks-section">
        <div v-if="primaryTask" class="task-card primary-task">
          <div class="block_head">
           <h2 class="sub-title">My Tasks</h2>
          </div>
          <div class="task-header">
            <span class="case-tag">{{ checkProperty(primaryTask, 'caseTag') }}</span>
            <span v-if="primaryTask.due && !isSection1CorrectionItem(primaryTask)" class="due-date flex items-center gap-2">Due: {{ primaryTask.due | formatDate }}
              <div class="IB_tooltip placement-left" v-if="checkProperty(primaryTask, 'type') === 'section1'">
                <span class="info-light">
                  <info-icon size="1.5x" class="custom-class"></info-icon>
                </span>
                <div class="tooltip_cnt">
                  <p>
                    Section 1 must be completed no later than your first day of paid work.
                  </p>
                </div>
              </div>
            </span>
          </div>
          <h3 class="task-title">{{ getTaskTitleDisplay(primaryTask) }}</h3>
          <p class="task-description">{{ getTaskDescription(primaryTask) }}</p>
          
          <div v-if="checkProperty(primaryTask,'type') === 'representative' && checkProperty(primaryTask,'verifierInfo', 'name') && checkProperty(primaryTask,'verifierInfo', 'email')" class="pending-suggestion">
            <p class="suggestion-info">
              Current suggestion: <strong>{{ checkProperty(primaryTask,'verifierInfo', 'name') }}</strong> 
              ({{ checkProperty(primaryTask,'verifierInfo', 'email') }})
            </p>
            <button class="btn-change" @click="handleChangeSuggestion(primaryTask)">Change</button>
          </div>

          <div class="task-actions" v-if="!(checkProperty(primaryTask,'type') === 'representative' && checkProperty(primaryTask,'verifierInfo', 'name'))">
            <button class="btn-primary" @click="handleTaskAction(primaryTask)">
              {{ getCTAtext(checkProperty(primaryTask, 'type'), checkProperty(primaryTask, 'title')) }}
            </button>
            <a v-if="checkProperty(primaryTask, 'type') === 'section1'" href="#" class="help-link" @click.prevent="showHelpModal = true">Need help?</a>
          </div>
          <div v-if="otherTasks.length > 0" class="other-tasks">
          <button 
            class="toggle-tasks d-flex items-center justify-between"
            :aria-expanded="showOtherTasks.toString()"
            aria-controls="other-tasks-list"
            @click="toggleOtherTasks"
          >
            Other tasks ({{ otherTasks.length }})
                <span style="display: inline-flex; align-items: center; justify-content: center; width: 16px;">
                <img
                    src="@/assets/images/main/down_arrow2.png"
                    style="height: 12px; width: 14px;"
                    :style="{ 
                    transform: showOtherTasks ? 'rotate(180deg)' : 'rotate(0deg)',
                    transformOrigin: 'center',
                    transition: 'transform 0.3s ease'
                    }"
                />
                </span>
          </button>
          
          <div 
            v-show="showOtherTasks"
            id="other-tasks-list"
            role="region"
            class="task-list"
          >
            <div 
              v-for="task in otherTasks" 
              :key="task.i9id"
              class="task-card secondary-task light-bg"
            >
              <div class="task-header">
                <span class="case-tag">{{ checkProperty(task, 'caseTag') }}</span>
                <span v-if="task.due && !isSection1CorrectionItem(task)" class="due-date">Due: {{ formatDate(checkProperty(task, 'due')) }}</span>
              </div>
              <h4 class="task-title">{{ getTaskTitleDisplay(task) }}</h4>
              <p v-if="task.description" class="task-description">{{ getTaskDescription(task) }}</p>
              
              <div v-if="checkProperty(task,'type') === 'representative' && checkProperty(task,'verifierInfo', 'name') && checkProperty(task,'verifierInfo', 'email')" class="pending-suggestion">
                <p class="suggestion-info">
                  Current suggestion: <strong>{{ checkProperty(task,'verifierInfo', 'name') }}</strong> 
                  ({{ checkProperty(task,'verifierInfo', 'email') }})
                </p>
                <button class="btn-change" @click="handleChangeSuggestion(task)">Change</button>
              </div>

              <div class="task-actions" v-if="!(checkProperty(primaryTask,'type') === 'representative' && checkProperty(primaryTask,'verifierInfo', 'name'))">
                <button class="btn-primary" @click="handleTaskAction(task)">
                  {{ getCTAtext(checkProperty(task, 'type'), checkProperty(task, 'title')) }}
                </button>
                <a v-if="checkProperty(task, 'type') === 'section1'" href="#" class="help-link" @click.prevent="showHelpModal = true">Need help?</a>
              </div>
            </div>
          </div>
        </div>
        </div>
        
      </section>
      <section v-else class="all-set-section">
        <div class="all-set-card">
          <div class="all-set-icon">✓</div>
          <h3>You're all set!</h3>
          <p>You'll get an email if anything else is needed.</p>
          <a v-if="checkProperty(i9Cases, 'length') > 0 && checkProperty(i9Cases[0], 'signedDocument')[0]" @click="viewPdf()" class="pdf-link">View Section 1 PDF</a>
        </div>
      </section>

      <section class="cases-section" v-if="checkProperty(i9Cases, 'length') > 0">
        <div class="db_block">
          <div class="block_head">
            <h2>My I-9 Cases</h2>
          </div>
          <div class="block_cnt cases_cnt">
            <div v-if="checkProperty(i9Cases, 'length') > 0" class="cases-list">
              <div 
                v-for="caseItem in i9Cases" 
                :key="caseItem.id"
                class="case-item"
              >
                <div class="case-info">
                  <h3 class="case-title">{{ checkProperty(caseItem, 'caseTag') }}</h3>
                  <p v-if="checkProperty(caseItem, 'caseType') === 'correction' || checkProperty(caseItem, 'caseType') === 'section1'" class="case-status" :class="{ 'action-needed': checkProperty(caseItem, 'caseType') === 'correction' || checkProperty(caseItem, 'caseType') === 'section1' }">
                    <template v-if="isSection1CorrectionItem(caseItem)">
                      Action Needed: Correct Section 1
                    </template>
                    <template v-else-if="checkProperty(caseItem, 'caseType') === 'section1' && !checkProperty(caseItem, 'questionnaireFilled')">
                      Action Needed: Complete Section 1
                    </template>
                    <template v-else-if="checkProperty(caseItem, 'caseType') === 'section1' && checkProperty(caseItem, 'questionnaireFilled') && checkProperty(caseItem, 'caseLabel')">
                      Action Needed: {{ getCaseLabelDisplay(caseItem) }}
                    </template>
                  </p>
                  <div v-if="checkProperty(caseItem, 'caseType') === 'Signed'" class="pdf-quick-link">
                    Section 1 PDF — Signed on {{ checkProperty(caseItem, 'signedCreatedOn') | formatDate }} • 
                    <a @click="viewPdf()" class="link">View</a> • 
                    <a @click="downloads3file(checkProperty(caseItem, 'signedDocument')[0])" class="link">Download</a>
                  </div>
                </div>
                <div class="right-align">
                  <span v-if="caseItem.due && !isSection1CorrectionItem(caseItem)" class="case-due-date">Due: {{ caseItem.due | formatDate }}</span>
                  <button @click="handleOpen(caseItem)" class="btn-open">
                    {{ isSection1CorrectionItem(caseItem) ? 'Open' : ([51].indexOf(getUserRoleId)>-1 && checkProperty(caseItem, 'caseLabel') == 'Waiting for you to sign' ? 'Review & Sign' : 'Open') }}</button>
                </div>
              </div>
            </div>
            <div v-else class="empty-state">
              <p>No Form I-9s yet.</p>
            </div>
          </div>
        </div>
      </section>

      <section class="cases-section" v-if="checkProperty(pafCases, 'length') > 0">
        <div class="db_block">
          <div class="block_head">
            <h2>My PAF Cases</h2>
          </div>
          <div class="block_cnt cases_cnt">
            <div v-if="checkProperty(pafCases, 'length') > 0" class="cases-list">
              <div 
                v-for="caseItem in pafCases" 
                :key="caseItem.id"
                class="case-item"
              >
                <div class="case-info">
                  <h3 class="case-title">{{ checkProperty(caseItem, 'caseTag') }}</h3>
                  <p class="case-status action-needed">
                    {{checkProperty(caseItem, 'caseLabel')}}
                  </p>
                  <div v-if="checkProperty(caseItem, 'viewDocuments', 'length') > 0" class="pdf-quick-link">
                    <template v-for="(doc, index) in checkProperty(caseItem, 'viewDocuments')" v-if="checkProperty(doc, 'document')">
                      {{ doc.label }} —  
                      <a @click="viewPdf(doc.document)" class="link">View</a> • 
                      <a @click="downloads3file(doc.document)" class="link">Download</a>
                    </template>
                  </div>
                </div>
                <button @click="$router.push({ name: 'PAF Requests', params: {pafId: caseItem.pafId}}).catch(err => { })" class="btn-open">Open</button>
              </div>
            </div>
            <div v-else class="empty-state">
              <p>No PAFs yet.</p>
            </div>
          </div>
        </div>
      </section>

      

      <div class="db_sec">
        <div class="db_cnt">
          <div class="db_block db_i9_block">
            <div class="block_head">
              <h2>Resources</h2>
            </div>
            <div class="block_cnt">
              <ul>
                <li>
                  <a @click="showDetailsPopup=true" class="i9_card">
                    <span class="card_icon">
                        <img  src="@/assets/images/documentImage.svg"/>
                    </span>
                    <label>Lists of Acceptable Documents</label>
                  </a>
                </li>
                <li>
                  <a href="https://www.uscis.gov/sites/default/files/document/forms/i-9instr.pdf" target="_blank" class="i9_card">
                    <span class="card_icon">
                        <img  src="@/assets/images/main/icon-textarea.svg"/>
                    </span>
                    <label>Official I-9 Instructions</label>
                  </a>
                </li>
                <li>
                  <a href="#" class="i9_card">
                    <span class="card_icon">
                        <img  src="@/assets/images/icons/search.png"/>
                    </span>
                                        <label>Internal Quick Guide</label>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="db_cnt">
          <div class="db_block">
            <div class="block_head">
              <h2>Help</h2>
            </div>
            <div class="block_cnt">
              <div class="help-content">
                <p>Questions? Contact your employer.</p>
                <!-- <div class="help-info">
                  <p>For technical support or questions about this system, please reach out to your HR department.</p>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="showReplaceModal" class="modal-overlay">
      <div class="modal-content">
        <h3>Replace Current Suggestion?</h3>
        <p>Replace the current suggestion for this case?</p>
        <div class="modal-actions">
          <button class="btn-secondary" @click="showReplaceModal = false">Cancel</button>
          <button class="btn-primary" @click="replaceSuggestion">Replace</button>
        </div>
      </div>
    </div> -->

    <div v-if="showUploadSuccess" class="toast success-toast">
      <span>✓</span>
      <p>Thank you—files received.</p>
      <button class="toast-close" @click="showUploadSuccess = false">×</button>
    </div>

    <div v-if="showInviteSent" class="toast info-toast">
      <span>✓</span>
      <p>Invite sent to {{ invitedPersonName }}. You'll be notified if anything else is needed.</p>
      <button class="toast-close" @click="showInviteSent = false">×</button>
    </div>
    <div class="workflow_view_wrap sidebar_sec" :class="{ 'listopen': showDetailsPopup }">
        <div class="workflow_overlay" @click="showDetailsPopup = false"></div>
        <div class="workflow_view_cnt" style="width:900px">
          <div class="sidebar_head">
            <span class="close" @click="showDetailsPopup = false;">
              <x-icon size="1.5x" class="custom-class"></x-icon>
            </span>
            <h2 class="popup-title">Lists of Acceptable Documents</h2>
          </div>
          <div class="sidebar_cnt" v-if="showDetailsPopup">
            <docListPopup />
          </div>
        </div>
      </div>
      <vs-popup
        class="document_modal document_modal-v2 "
        :class="{ 'expand': expandModal, 'custom_close_doc_modal':showCloseIcon }"
        :title="checkProperty(selectedFile, 'name')"
        :active.sync="docPrivew"
        >
        <div class="document_actions" @click="expandModal = !expandModal">
          <figure v-if="!expandModal" class="maximize-img"><img src="@/assets/images/maximize.png"  width="18" height="18"/></figure>
          <figure v-else class="minimize-img"><img src="@/assets/images/minimize.png"  width="20" height="20"/></figure>
        </div>
        <div class="custom_close" v-if="showCloseIcon">
          <figure class="close_icon" @click="showConfrmLetterPopup = true;updateletterLoading = false;errorMessage=''">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 20 20"><path class="a" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.3,12.708L12.705,14.3A36.72,36.72,0,0,0,10,11.6a37.242,37.242,0,0,0-2.706,2.7L5.7,12.708A31.208,31.208,0,0,0,8.4,10,30.784,30.784,0,0,0,5.7,7.3L7.292,5.7s2.541,2.7,2.706,2.7,2.708-2.7,2.708-2.7L14.3,7.3A36.62,36.62,0,0,0,11.591,10C11.591,10.183,14.3,12.708,14.3,12.708Z"/></svg>
          </figure>
        </div>
        <h2>
          <img
            :class="{
              pdf_view_download: docType == 'pdf',
              office_view_download: docType == 'office',
              image_view_download: docType == 'image',
            }"
            class="download-button"
            @click="downloads3file(selectedFile)"
            src="@/assets/images/download.svg"
            />
        </h2>
        <div class="pdf_loader">
          <figure v-if="formSubmited && !saveEditedFile" class="loader loader2">
            <img src="@/assets/images/main/loader.gif" />
          </figure>
          <template v-if="docType == 'office'">
            <div style="height: 90vh">
              <div id="placeholder" style="height: 100%"></div>
            </div>
          </template>
          <template v-else-if="docType == 'image'">
            <img :src="docValue" />
          </template>
          <template v-else-if="docType == 'pdf'">
            <div class="pdf" style="height: 90vh">
              <iframe
                v-if="docValue != ''"
                border="0"
                style="border: 0px"
                :src="docValue"
                height="100%"
                width="100%"
                >
              </iframe>
            </div>
          </template>
        </div>
      </vs-popup>
      <vs-popup class="help-modal" title="Getting Started With Section 1" :active.sync="showHelpModal">
        <div class="help-content-modal">
          <ul class="help-list">
            <li>
              <strong>What Section 1 is</strong>
              <p>Section 1 is completed by you as part of Form I-9. It collects your personal information and includes your attestation of U.S. work authorization.</p>
            </li>
            <li>
              <strong>What information you need</strong>
              <p>You’ll need your current address, your Social Security Number if your employer uses E-Verify, and details about your citizenship or immigration status.</p>
            </li>
            <li>
              <strong>How long it takes</strong>
              <p>Most people complete Section 1 in 5–10 minutes.</p>
            </li>
            <li>
              <strong>Save & return</strong>
              <p>You can save your progress and finish later before your employer completes Section 2.</p>
            </li>
          </ul>
          <div class="help-footer">
            <p>If you have any questions, please contact your employer.</p>
          </div>
        </div>
      </vs-popup>
      <inviteVerifier v-if="requestAddVerifier" @closeAddVerifierPopUp="closeAddVerifierPopUp" :isCallFromBen="false" :i9Id="checkProperty(i9Cases[0], 'i9id')"/>
  </div>
</template>

<script>
import docListPopup from "@/views/i-9Module/docListPopup.vue";
import NoDataFound from "@/views/common/noData.vue";
import noList from "../common/noList.vue";
import { XIcon } from "vue-feather-icons";
import inviteVerifier from "@/views/i-9Module/inviteVerifier.vue";
import { InfoIcon } from 'vue-feather-icons'

export default {
  name: 'EmployeeDashboard',
  components: {
    docListPopup,
    XIcon,
    noList,
    NoDataFound,
    inviteVerifier,
    InfoIcon
  },
  data() {
    return {
      showHelpModal: false,
      docType: false,
      docPrivew: false,
      docValue: "",
      selectedFile: null,
      formSubmited:false,
      showDetailsPopup: false,
      loading: false,
      error: false,
      showOtherTasks: false,
      showReplaceModal: false,
      showUploadSuccess: false,
      showInviteSent: false,
      invitedPersonName: '',
      i9Cases: [],
      pafCases: [],
      showCloseIcon: false,
      expandModal: false,
      requestAddVerifier: false,
      tasks: []
    }
  },
  computed: {
    hasTasks() {
      return this.tasks.length > 0;
    },
    pendingTasks() {
      return this.tasks.length;
    },
    sublineText() {
      return this.checkProperty(this.tasks, 'length') > 0 
        ? `You have ${this.tasks.length} task${this.tasks.length > 1 ? 's' : ''} to complete.`
        : "You're all set. You'll get an email if anything else is needed.";
    },
    primaryTask() {
      return this.checkProperty(this.tasks, 'length') > 0 ? this.tasks[0] : null;
    },
    otherTasks() {
      return this.tasks.length > 1 ? this.tasks.slice(1) : [];
    }
  },
  methods: {
    isSection1CorrectionItem(item) {
      return this.checkProperty(item, 'type') === 'correction'
        || this.checkProperty(item, 'caseType') === 'correction'
        || this.checkProperty(item, 'title') === 'Correct Section 1'
        || this.checkProperty(item, 'caseLabel') === 'Correct Section 1';
    },
    getTaskTitleDisplay(task) {
      if (this.isSection1CorrectionItem(task)) {
        return 'Correct Section 1';
      }
      if ([51].indexOf(this.getUserRoleId) > -1 && this.checkProperty(task, 'title') === 'Waiting for employee to sign') {
        return 'Waiting for you to sign';
      }
      return this.checkProperty(task, 'title');
    },
    getCaseLabelDisplay(caseItem) {
      if ([51].indexOf(this.getUserRoleId) > -1 && this.checkProperty(caseItem, 'caseLabel') === 'Waiting for employee to sign') {
        return 'Waiting for you to sign';
      }
      return this.checkProperty(caseItem, 'caseLabel');
    },
    handleOpen(caseItem){
      if(this.isSection1CorrectionItem(caseItem)){
        this.openSection1Questionnaire(this.checkProperty(caseItem, 'i9id'))
        return;
      }
      if(this.checkProperty(caseItem, 'questionnaireFilled')){
        this.$router.push('/i9-details/'+ this.checkProperty(caseItem, 'i9id'))
        return;
      }
      this.$router.push('/I9-questionnaire/'+ this.checkProperty(caseItem, 'i9id'))
    },
    handleEsc(e) {
      if (e.key === 'Escape' && this.showHelpModal) {
        this.showHelpModal = false
      }
    },
    handleChangeSuggestion(task){
      const id = this.checkProperty(task, 'i9id');
        let query = {openAssign: 2}
        this.$router.push({
          path: `/i9-details/${id}`,
          query: query
        }).catch(err => {
        });
    },
    closeAddVerifierPopUp(data){
      let postData = {
          "i9Id": this.checkProperty(this.i9Cases[0], 'i9id'),
          // "verifierType": this.checkProperty(this.caseDetails, 'verifierType'),
          }
          let obj = {
            '_id' : data['_id'],
            'customId':data['customId'],
            'name':data['name'],
            "firstName": data['firstName'],
            "middleName": data['middleName'],
            "lastName": data['lastName'],
            'email':data['email'],
            'alreadyExisted':data['alreadyExisted'],
            'phone':data['phone'],
            'phoneCountryCode':data['phoneCountryCode'],
            "tempUser":this.checkProperty(data,'tempUser')
          }
          postData['verifierInfo'] = obj
          postData['verifyId'] = 4
          postData['verifierId'] = obj['_id']
          postData['authroizedRepresent'] =true
          postData['chooseVerifyAndSign'] =true
          let path = '/i9/assign-verifier'
          this.$store.dispatch('commonAction', ({'data':postData, 'path':path})).then((response)=>{
            this.showToster({message:response.message ,isError:false});
            this.requestAddVerifier=false;
            this.getStats()
          }).catch((err)=>{
              this.showToster({message:error,isError:true });
          })
    },
    viewPdf(doc){
      let document = {}
      if(doc){
        document = doc
      }else {
        document = this.i9Cases[0].signedDocument[0]
      }
      document.download = false;
      document.viewmode = true;
      this.selectedFileForEdit =false;
      this.showCloseIcon = false;
      if ( _.has(document ,'viewmode') && this.checkProperty(document,'viewmode')==false ) {
        this.selectedFileForEdit =true;
      }
      this.expandModal= false;
      if (
        this.checkProperty(this.getPetitionDetails, "caseNo") &&
        this.checkProperty(document, "name")
      ) {
        let docName = _.cloneDeep(document["name"]);
        try{
          if(!docName.includes(this.checkProperty(this.getPetitionDetails, "caseNo"))){
            document["name"] = docName;
          }
        }catch(err){
        }
      }
      var _self = this;
      this.formSubmited = false;
      if (_.has(document, "path")) {
        document["url"] = document["path"];
        document["document"] = document["path"];
      }
      if (_.has(document, "url")) {
        document["path"] = document["url"];
        document["document"] = document["url"];
      }
      if (_.has(document, "document")) {
        document["path"] = document["document"];
        document["url"] = document["document"];
      }
      this.selectedFile = document;
      this.docValue = "";
      this.docPrivew = false;
      this.docType = false;
      this.docType = this.findmsDoctype(document);
      this.showCloseIcon = false;
      if (this.docType == "office" || this.docType == "image" || this.docType == "pdf") {
        document.url = document.url.replace(this.$globalgonfig._S3URL, "");
        document.url = document.url.replace(this.$globalgonfig._S3URLAWS, "");
        let postdata = {
          keyName: document.url,
          petitionId: document["petitionId"],
        };
        this.$store.dispatch("getSignedUrl", postdata).then((response) => {
          this.docValue = response.data.result.data;
          if (this.docType == "office") {
          document.getElementById("placeholder").innerHTML =
            "  <div  id='placeholder2' style='height:100%'></div>";
          let _editing = false;
          if ([48, 50, 51].indexOf(this.getUserRoleId) > -1) {
            _editing = false;
          }
          let docViewUrl ='https://immibox.com/api/petition/post-edited-document';
          if(_.has(this.$globalgonfig, 'DOC_VIEW_URL')){
            docViewUrl = this.$globalgonfig['DOC_VIEW_URL'];
          }
          let entityId = 'cover_letter';
          if(this.checkProperty(document,'entityId')){
            entityId = document['entityId'];
          }
          if ( _.has(document ,'viewmode') && document.viewmode==false ) {
            _editing = true;
          if(_.has(document,'type') && _self.checkProperty(document, 'type') == 'Letter' && _.has(document,'generated') &&
          (_self.checkProperty(document, 'generated') == true || _self.checkProperty(document, 'generated') == 'true') && !document['parentId'] 
            ){
            this.showCloseIcon = true; 
          } 
        }
        var _ob = {};
        if (document.editedDocument) {
          _ob = {
           petitionId:this.checkProperty(this.petition, '_id'),
            name: document.name,
            _id: document._id,
            extn: "docx",
            formLetterType: "Letter",
            parentId: document.parentId,
          };
        } else {
          _ob = {
            name: document.name,
              petitionId:this.checkProperty(this.petition, '_id'),
            _id: document._id,
            extn: "docx",
            formLetterType: "Letter",
            parentId: document._id,
          };
        }
        var nid = document._id +  Math.round(+new Date()/1000)
        window.docEditor = new DocsAPI.DocEditor("placeholder2", {
          document: {
            c: "forcesave",
            fileType: "docx",
            key: nid,
            userdata: JSON.stringify(_ob),
            title: document.name,
            url: response.data.result.data,
            permissions: {
              edit: _editing,
              download: true,
              reader: false,
              review: false,
              comment: false,
            },
          },

          documentType: "word",
          height: "100%",
          width: "100%",

          editorConfig: {
            userdata: JSON.stringify(_ob),
            callbackUrl:
            docViewUrl+"?entityId="+entityId+"&payload=" +
              JSON.stringify(_ob) +
              "&token=" +
              _self.$store.state.token +
              "&name=" +
              document.name.replace(".docx", ""),
            customization: {
              logo: {
                image: "https://immibox.com/app/favicon.png",
                imageDark: "https://immibox.com/app/favicon.png",
                url: "https://immibox.com",
              },
              anonymous: {
                request: false,
                label: "Guest",
              },
              chat: false,
              comments: false,
              compactHeader: false,
              compactToolbar: true,
              compatibleFeatures: false,
              feedback: {
                visible: false,
              },
              forcesave: true,
              help: false,
              hideNotes: true,
              hideRightMenu: true,
              hideRulers: true,
              layout: {
                toolbar: {
                  collaboration: false,
                },
              },
              macros: false,
              macrosMode: "warn",
              mentionShare: false,
              plugins: false,
              spellcheck: false,
              toolbarHideFileName: true,
              toolbarNoTabs: true,
              uiTheme: "theme-light",
              unit: "cm",
              zoom: 100,
            },
          },
          events: {
            onReady: function () {},
            onDocumentStateChange: function (event) {
              var url = event.data;
              if (!event.data) {
                if (document.editedDocument) {
                }
              }
            },
          },
        });
      }

      if (this.docType == "pdf") {
        var formAndLetterId = document._id;
        let parentId = '';
        var  viewmode = 0;
        let pdfViewUrl ='https://immibox.com/viewer/pdfjs-dist/web/viewerv2.html';
        
        if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
          pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
        }
        if(_.has(document ,'viewmode')){
          if (document.viewmode) {
            viewmode = 0;
          }else{
            viewmode = 1;
            viewmode=viewmode+"&depLabel="+document.depLabel+"&depType="+document.depType+"&docUserType="+document.docUserType+"&generated="+document.generated+"&parentId="+parentId+"&formAndLetterId="+formAndLetterId+"&save=v2&docname="+document.name+"&posturl="+this.$globalgonfig._APIURL+"/&petitionId="+this.$route.params.itemId+"&entityId="+document.entityId+"&token="+this.$store.state.token
            if(_.has(this.$globalgonfig, 'PDF_EDIT_URL')){
              pdfViewUrl = this.$globalgonfig['PDF_EDIT_URL'];
              
              }
          }

        }
        if(this.getPetitionTab != 'Forms and Letters'){
          viewmode= 0; //Disabled Edit
          if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
            pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
          }
          
        }
        
        this.docValue =
        pdfViewUrl+"?view=" +
          viewmode +
          "+&file=" +
          encodeURIComponent(response.data.result.data);
      }
      this.docPrivew = true;
      });
      } else {
      this.downloads3file(document);
      }
    },
    getCTAtext(type, title=''){
      if(type === 'Upload document copies'){
        return 'Upload'
      }else if(type === 'correction' || title === 'Correct Section 1'){
        return 'Continue'
      }else if(type === 'section1'){
        if(title == 'Waiting for preparer/translator to sign'){
          return 'Open'
        }
        if(title == 'Waiting for you to sign'){
          return 'Review & Sign'
        }
        return 'Continue'
      }else if(type === 'representative'){
        return 'Submit name + email'
      }else if(type === 'remote_review'){
        return 'Join call'
      }else if(type === 'VIEW_AND_CONFIRM'){
        return 'View & Confirm'
      }else{
        return 'Continue'
      }
    },
    getTaskDescription(task){
      if(task.type === 'Upload document copies'){
        return 'Please upload copies of your supporting documents for verification.'
      }else if(task.type === 'section1' && !task.questionnaireFilled){
        return 'Please complete your personal information for Form I-9 verification.'
      }else if(task.type === 'remote_review'){
        return `Scheduled for ${this.formatDateTime(task.scheduledDetails)}`
      }
    },
    getStats(){
      this.error = false
      this.loading = true
      this.tasks = []
      this.$vs.loading({text: 'Checking your tasks...', target: this.$refs.db_container})
      this.$store.dispatch('commonAction', {data:{}, path:'/dashboard/get-dashboard-stats'}).then((res)=>{
        if(res){
          if(this.checkProperty(res, 'i9', 'tasks') && this.checkProperty(res['i9'], 'tasks', 'length') > 0){
            this.tasks = [...this.tasks, ...this.checkProperty(res, 'i9', 'tasks')];
          }
          if(this.checkProperty(res, 'paf', 'tasks') && this.checkProperty(res['paf'], 'tasks', 'length') > 0){
            this.tasks = [...this.tasks, ...this.checkProperty(res, 'paf', 'tasks')];
          }
          if(this.checkProperty(res, 'i9', 'cases') && this.checkProperty(res['i9'], 'cases', 'length') > 0){
            this.i9Cases = this.checkProperty(res, 'i9', 'cases');
          }
          if(this.checkProperty(res, 'paf', 'cases') && this.checkProperty(res['paf'], 'cases', 'length') > 0){
            this.pafCases = this.checkProperty(res, 'paf', 'cases');
          }
          //   if(res['paf'] && res['paf']['length']>0){
            //     this.getAwaitingSignCount(res['paf']);
            //     this.getEmployeeNotAssignedStats(res['paf']);
            //   }
            //   else{
              //     this.getAwaitingSignCount([]);
              //     this.getEmployeeNotAssignedStats([]);
              //   }
            }
            this.$vs.loading.close()
            this.loading = false
          }).catch((err)=>{
            this.$vs.loading.close()
            this.error = true
            //  this.getAwaitingSignCount([]);
          //  this.getEmployeeNotAssignedStats([]);
      })
    },
    toggleOtherTasks() {
      this.showOtherTasks = !this.showOtherTasks;
    },
    
    retry() {
      this.loading = true;
      this.error = false;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    
    formatDate(dateString) {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('en-US', options);
    },
    formatDateTime({ scheduledOn, scheduledTime, scheduledTimezone }) {
      const [year, month, day] = scheduledOn.split('T')[0].split('-').map(Number);
      const [hour, minute] = scheduledTime.split(':').map(Number);
      let assumedUtcMillis = Date.UTC(year, month - 1, day, hour, minute, 0);
      function tzOffsetMinutesForInstant(utcMillis, timeZone) {
        const dt = new Date(utcMillis);
        const fmt = new Intl.DateTimeFormat('en-US', {
          timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        });
        const parts = fmt.formatToParts(dt).reduce((acc, p) => {
          if (p.type !== 'literal') acc[p.type] = p.value;
          return acc;
        }, {});
        const wallAsUtcString = `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}Z`;
        const wallAsUtcMillis = Date.parse(wallAsUtcString);
        return Math.round((wallAsUtcMillis - dt.getTime()) / 60000); // minutes
       }
      const offsetMinutes = tzOffsetMinutesForInstant(assumedUtcMillis, scheduledTimezone);
      const realUtcMillis = assumedUtcMillis - offsetMinutes * 60000;
      const realDate = new Date(realUtcMillis);
      const options = {
        timeZone: scheduledTimezone,
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZoneName: 'short'
      };
      const formatted = new Intl.DateTimeFormat('en-US', options).format(realDate);
      return formatted;
    },
    openSection1Questionnaire(i9Id) {
      this.$router.push({
        name: 'I9-questionnaire',
        params: {
          itemId: i9Id,
          action: 'section-1'
        }
      }).catch(err => {
        if (err && err.name !== 'NavigationDuplicated') console.error(err);
      });
    },
    handleTaskAction(task) {
      if(this.isSection1CorrectionItem(task)){
        this.openSection1Questionnaire(this.checkProperty(task, 'i9id'))
        return;
      }
      if(this.checkProperty(task, 'type') === 'section1'){
        if(task.questionnaireFilled){
          this.$router.push('/i9-details/'+ this.checkProperty(task, 'i9id'))
          return;
        }
        this.$router.push('/I9-questionnaire/'+ this.checkProperty(task, 'i9id'))
      }else if(this.checkProperty(task, 'type') === 'remote_review' || this.checkProperty(task, 'type') === 'representative'){
        const id = this.checkProperty(task, 'i9id');
        let query = {}
        if(this.checkProperty(task, 'type') === 'remote_review'){
          query['joinCall'] = '1'
        }else{
          query['openAssign'] = '1'
        }
        this.$router.push({
          path: `/i9-details/${id}`,
          query: query
        }).catch(err => {
          if (err && err.name !== 'NavigationDuplicated') console.error(err);
        });
      } else if (this.checkProperty(task, 'type') === 'VIEW_AND_CONFIRM') {
        let params = {
          openSignAck: '1',
          pafId: this.checkProperty(task, 'pafId')
        };
        this.$router.push({
          name: 'PAF Requests',
          params: params,
        }).catch(err => {
          if (err && err.name !== 'NavigationDuplicated') console.error(err);
        });
      }
    },
    
    replaceSuggestion() {
      this.invitedPersonName = 'New Representative';
      this.showInviteSent = true;
      this.showReplaceModal = false;
      this.tasks = this.tasks.filter(task => task.type !== 'suggest_ar');
    }
  },
  
  mounted() {
    this.getStats()
    window.addEventListener('keydown', this.handleEsc)
  },
  beforeDestroy(){
    window.removeEventListener('keydown', this.handleEsc)
  }
}
</script>

<style lang="scss" scoped>

</style>